/// <amd-module name="Environments/CreatePanel/Common/Utils" />
import { EnvironmentResourceType } from "DistributedTask/Client/Contracts/TaskAgent";
import * as Resources from "Environments/CreatePanel/Resources";
import { ResourceSectionTypes } from "Environments/EnvironmentsCommon/Utils";

import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

import { IPanelTitleProps } from "VSSUI/Panel";
import { TitleSize } from "VSSUI/Header";

export interface IResource {
    name: string;
    description: string;
    resourceType: EnvironmentResourceType;
    imageLocation: string;
    imageAltText?: string;
    isIcon?: boolean;
    providerCreateContributionId: string;
    componentType: string;
}

export function getResources(pageContext: IVssPageContext): IResource[] {
    let resources: IResource[] = [{
        name: Resources.AddResourceLater,
        description: Resources.AddResourceLaterDescription,
        resourceType: EnvironmentResourceType.Undefined,
        imageLocation: "ms.vss-environments-web/environments-create-panel/ProviderIcons/BorderDot.svg",
        imageAltText: Resources.NoResourceImageAltText,
        providerCreateContributionId: "",
        componentType: ""
    }];

    resources.push({
        name: Resources.Kubernetes,
        description: Resources.KubernetesDescription,
        resourceType: EnvironmentResourceType.Kubernetes,
        imageLocation: "ms.vss-environments-web/environments-create-panel/ProviderIcons/kubernetes.svg",
        imageAltText: Resources.KubernetesResourceImageAltText,
        providerCreateContributionId: "ms.vss-environments-web.kubernetes-create-resource-details",
        componentType: ResourceSectionTypes.Kubernetes
    });

    if(isFeatureFlagEnabled(pageContext, "DistributedTask.Environments.EnvironmentVirtualMachineResource", false)) {
        resources.push({
            name: Resources.VirtualMachine,
            description: Resources.VirtualMachineDescription,
            resourceType: EnvironmentResourceType.VirtualMachine,
            imageLocation: "ms.vss-environments-web/environments-create-panel/ProviderIcons/virtualmachine.svg",
            imageAltText: Resources.VirtualMachineResourceImageAltText,
            providerCreateContributionId: "ms.vss-environments-web.virtualmachines-create-resource-details",
            componentType: ResourceSectionTypes.newVmProvider
        });
    }
    
    return resources;
}

export class PageKey {
    public static CreateResourceView = "create-resource";
    public static EditEnvironmentView = "edit-environment";
    public static AddEnvironmentView = "add-environment";    
    public static AddResourceView = "add-resource";
};

export function getErrorMessage(error: any): string{
    let errorMessage: string = error ? error.message || error : "";
    return errorMessage;
}

export class Operation {
    public static Create: string = "create";
    public static Update: string = "update";
}

export function getTitle(text: string): IPanelTitleProps {
    const panelTitle = {
        text: text,
        size: TitleSize.Large
    } as IPanelTitleProps;

    return panelTitle;
}

export const SingleLineTextMaxLength = 256;
export const MultiLineTextMaxLength = 1024;

export const Area = "EnvironmentDeployment";

export namespace FeatureNames {
    export const EnvironmentCreationWorkFlow = "EnvironmentCreateWorkFlow";
    export const EnvironmentCreateWithResourceType = "EnvironmentCreateWithResourceType";
    export const EnvironmentCreationType = "EnvironmentCreationType";
}

export namespace Action {
    export const EnvironmentCreationType = "EnvironmentCreationType";
    export const EnvironmentCreateWithResourceType = "EnvironmentCreateWithResourceType";
    
}
